import React, { useContext } from 'react';

import { TrackingContext } from '../../TrackingContext';
import { ThemeInfoFullWidth } from './ThemeInfo';
import verticalStyles from './themeCard.scss';
import { ThemeCardFullDisplayContainer } from './ThemeCardComponents/ThumbnailContainers';
import { findThumbnailTheme } from './ThemeCardComponents/util';
import { ThemeCardProps } from './ThemeCard';
import useBuildThemeAnalyticsBaseProps from '../../hooks/useBuildThemeAnalyticsBaseProps';

const ThemeCardFullDisplay: React.FC<ThemeCardProps> = ({
  themeFamily,
  onClick,
  selected = null,
  dashboard = false,
  hideInvitationLink = false,
}) => {
  const { track } = useContext(TrackingContext);
  const { getThemeAnalyticsBaseProps } = useBuildThemeAnalyticsBaseProps();

  if (!themeFamily?.themes) {
    return null;
  }

  // By default, primary theme is the first theme in the family
  const theme = themeFamily.themes[0];

  const thumbnailTheme = findThumbnailTheme({
    selected,
    theme,
    themeFamily,
  });

  const thumbnailClickHandler = () => {
    if (onClick && !selected && thumbnailTheme?.id) {
      onClick(thumbnailTheme?.id);
      track('Design Previewed', {
        ...getThemeAnalyticsBaseProps(thumbnailTheme),
        selection: 'theme thumbnail',
      });
    }
  };

  return (
    <div
      className={`${verticalStyles.themeCard} ${dashboard ? verticalStyles.dashboardCard : ''}`}
      data-testid={`theme-${thumbnailTheme?.id}`}
    >
      <div>
        <ThemeCardFullDisplayContainer clickHandler={thumbnailClickHandler} theme={thumbnailTheme} />
        <ThemeInfoFullWidth
          themeFamily={themeFamily}
          thumbnailTheme={thumbnailTheme}
          onClick={onClick}
          selected={selected}
          dashboard={dashboard}
          hideInvitationLink={hideInvitationLink}
        />
      </div>
    </div>
  );
};

export default ThemeCardFullDisplay;
